import dayjs from "dayjs";

export const checkDate = (date) => {
  if (date) {
    return dayjs(date).toDate();
  }
  return dayjs().toDate();
};
